import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';

class Banners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const closeBtn = <button className="close" onClick={this.toggle}>&times;</button>;

    return (
      <div className="tab-banners">

        <Row className="mb-4 align-items-center">
          <Col md={8} className="mb-3 mb-md-0">
            <h3 className="mb-md-0 text-center text-md-left">Web Display Banners</h3>
            <p className="mb-0 text-center text-md-left">Lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
          </Col>

          <Col md={4}>
            <Form>
              <Row form>
                <Col>
                  <FormGroup className="dropdown-toggle mb-0 input-inline">
                    <Input type="select" name="select" id="filterCategory">
                      <option value="">All Sizes</option>
                      <option value="1">300 x 250 – Inline Rectangle</option>
                      <option value="2">728 x 90 – Leaderboard</option>
                      <option value="3">160 x 600 – Wide Skyscraper</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Col>

        </Row>
        <Row>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x300x250"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Medspa: “Apply For A Medspa Loan”</h5>
                <p className="mb-0">300x250 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x160x600"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Medspa: “Apply For A Medspa Loan”</h5>
                <p className="mb-0">160x600 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x728x90"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Medspa: “Apply For A Medspa Loan”</h5>
                <p className="mb-0">728x90 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x300x250"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Funeral: “Apply For A Funeral Loan”</h5>
                <p className="mb-0">300x250 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x160x600"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Funeral: “Apply For A Funeral Loan”</h5>
                <p className="mb-0">160x600 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x728x90"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Funeral: “Apply For A Funeral Loan”</h5>
                <p className="mb-0">728x90 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x300x250"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Dental: “Apply For A Dental Loan”</h5>
                <p className="mb-0">300x250 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x160x600"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Dental: “Apply For A Dental Loan”</h5>
                <p className="mb-0">160x600 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

          <Col md={6} lg={4}>
            <Card className="banner-card" tag={Link} to="#" onClick={this.toggle}>
              <CardBody className="d-flex justify-content-center align-items-center">
                <div className="banner x728x90"></div>
              </CardBody>
              <CardFooter className="py-2">
                <h5>Dental: “Apply For A Dental Loan”</h5>
                <p className="mb-0">728x90 &nbsp;–&nbsp; <span className="text-primary"><strong>Get Embed Code</strong></span></p>
              </CardFooter>
            </Card>
          </Col>

        </Row>

        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg" className="no-scroll-modal-content">
          <ModalHeader toggle={this.toggle} close={closeBtn}>HTML Embed Code - 300x250</ModalHeader>
          <ModalBody>
            <Container fluid>
              <Row>
                <Col lg="auto" className="pl-lg-0 mb-3 mb-lg-0">
                  <img className="w-100" src="https://secure.lendingusa.com//web_ads/FuneralBanner3_300x250.gif" alt="Banner" />
                </Col>
                <Col className="pl-lg-1 pr-lg-0">
                  <FormGroup>
                    <Label for="embedCode">HTML Embed Code</Label>
                    <Input type="textarea" name="text" id="embedCode" className="w-100" rows="6" value='<a href="https://secure.lendingusa.com/secure/credit_app.aspx?lm=1&indie=tRV3&iframe=2&aid=uRX4eUBxBy%2FbQH0110gdYQ%3D%3D&pid=2652" border="0" target="_blank"><img src="https://secure.lendingusa.com//web_ads/FuneralBanner3_300x250.gif" alt="Banner" border="0" /></a>' readOnly />
                  </FormGroup>
                  <Button color="primary" className="w-100">Copy Code to Clipboard</Button>
                </Col>
              </Row>
            </Container>
          </ModalBody>
        </Modal>

      </div>
    )
  }
}

export default Banners;
